import { render, staticRenderFns } from "./OneVillageOneProductPage.vue?vue&type=template&id=83025892&scoped=true&"
import script from "./OneVillageOneProductPage.vue?vue&type=script&lang=js&"
export * from "./OneVillageOneProductPage.vue?vue&type=script&lang=js&"
import style0 from "./OneVillageOneProductPage.vue?vue&type=style&index=0&id=83025892&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83025892",
  null
  
)

export default component.exports